<div [class.mobile-view]="isMobile()" [class.desktop-view]="!isMobile()">
  <app-desktop *ngIf="!isMobile()"></app-desktop>
  <router-outlet *ngIf="isMobile()"></router-outlet>
  <modal-error-host></modal-error-host>
  <modal-info-host></modal-info-host>
</div>
